export default "assets/images/texture_terroirs_map-84813d6e.png";